// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"cartList_is-mob__ckxrJ","is-desk":"cartList_is-desk__X_5Lw","wrapper":"cartList_wrapper__GqysK"};